import { IonContent, IonPage } from '@ionic/react';
import React, { FormEvent } from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import styles from './css/Home.module.css';
import axiosInstance from '../services/AxiosInstance';

interface HomeProps extends RouteComponentProps {
  // Define the props here
}

interface HomeState {
  // Define the state here
  Email: string;
  Password: string;
  posting: boolean;
}

class Home extends React.Component<HomeProps, HomeState>
{
  constructor(props: HomeProps) {
    super(props);

    // Initialize the state here
    this.state = {
      Email: '',
      Password: '',
      posting: false,
    };
  }

  goToPortal() {
    const { history } = this.props;
    const value = localStorage.getItem('WelcomeSeen' + localStorage.getItem("id"));
    if (!value) {
      history.push("/WelcomeScreen");
    }
    else {
      history.push("/Portal");
    }
  }

  handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // Handle the form submission here
    this.setState({ posting: true });

    if (this.state.Email == "") {
      alert("Voer een emailadres in");
      this.setState({ posting: false });
      window.location.reload();
      return;
    }
    if (this.state.Password == "") {
      alert("wachtwoord kan niet leeg zijn");
      this.setState({ posting: false });
      window.location.reload();
      return;
    }
    try {
      axiosInstance.post("/Users/Authenticate", JSON.stringify(this.state), {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": "cd4ed8b372ef47189706abe7ae615788",
        },
      }
      )
        .then((res) => {
          let user = res.data;
          if (user.roles[0] == "Employee") {
            localStorage.setItem("id", "" + user.id);
            localStorage.setItem("userName", user.userName);
            localStorage.setItem("token", user.jwtToken);
            localStorage.setItem("refreshToken", user.refreshToken);
            localStorage.setItem("organisationId", user.organisation);
            localStorage.setItem("firstName", user.voornaam);
            localStorage.setItem("lastName", user.familienaam);
            localStorage.setItem("role", user.roles[0]);

            //Navigate to Portal
            this.goToPortal();
          } else {
            alert("Geen geldig email of wachtwoord.");
          }
        }).catch((err) => {
          console.error(err);
          alert("Geen geldig email of wachtwoord.");
          this.setState({ posting: false });
        });
    }
    catch (e) {
      console.error(e);
      alert("er is iets foutgelopen!");
      this.setState({ posting: false });
    }
  };

  handleMailAddrChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ Email: event.target.value });
  };

  handlePwdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ Password: event.target.value });
  };

  render() {
    const isDesktop = window.innerWidth > 768;

    return (
      <IonPage ion-no-header="true">
        <IonContent fullscreen ion-no-border="true">

          <div style={{ backgroundImage: 'linear-gradient(#98CBFE, #339)', height: '100vh', width: '100wh', textAlign: 'center' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ marginTop: '1%', marginBottom: '-5%' }}>

                <p className={`${styles.textFont} ${styles.headerText}`}>
                  Inloggen
                </p>

                <div className={(styles.logoView)}>
                  <p className={`${styles.textFont} ${styles.logo}`}>
                    WorkerPro
                  </p>
                  {isDesktop && (
                    <p className={`${styles.textFont} ${styles.underlogo}`}>
                      De intelligente mental wellbeing app
                    </p>
                  )}
                </div>

                <form onSubmit={this.handleSubmit}>
                  <div className={(styles.inputView)}>
                    <input className={(styles.inputText)} placeholder='E-mailadres' name='MailAddr'
                      value={this.state.Email}
                      onChange={this.handleMailAddrChange} />
                  </div>
                  <div className={(styles.inputView)}>
                    <input className={(styles.inputPwd)} type='password' placeholder='Wachtwoord' name='PWD'
                      value={this.state.Password}
                      onChange={this.handlePwdChange} />
                  </div>

                  <div className={(styles.buttonView)}>
                    <button className={(styles.button)} type='submit' disabled={this.state.posting}>
                      <p className={(styles.buttonText)}>Log In</p>
                    </button>
                  </div>
                </form>

                <p className={`${styles.textFont} ${styles.info}`} style={{ marginBottom: "1px" }}>
                  Nog geen account? <Link className={(styles.textFont)} style={{ fontSize: 15, color: "#FFF" }} to="/signup"> Registreer</Link>
                </p>


              </div>
            </div>
          </div>

        </IonContent>
      </IonPage>
    )
  }
};

export default withRouter(Home);
